import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";

// Shown only where the bootstrap (public/index.html) decided consent is required (EU/UK/CH by default, or everyone when CONSENT_MODE=all).
export function ConsentBanner() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const check = () => setOpen(!!window.__urbanConsentRequired && !window.__urbanConsentDecided);
    check();
    window.addEventListener("urban-consent-ready", check);
    return () => window.removeEventListener("urban-consent-ready", check);
  }, []);
  if (!open) return null;
  const decide = (granted) => { window.__urbanSetConsent?.(granted); setOpen(false); };
  return (
    <div className="fixed inset-x-3 bottom-3 sm:inset-x-auto sm:right-5 sm:bottom-5 sm:max-w-sm z-[90] rounded-2xl bg-[#0F0F0F] text-white p-4 shadow-2xl" role="dialog" aria-label="Cookie consent" data-testid="consent-banner">
      <p className="text-sm leading-snug inline-flex gap-2"><Cookie size={18} className="shrink-0 mt-0.5 text-[#E04F33]" aria-hidden="true" />
        We use analytics and marketing cookies to understand how the site is used and to measure our ads. Essential cookies for ordering always stay on. <a href="/privacy" className="underline">Privacy</a></p>
      <div className="mt-3 flex gap-2">
        <button onClick={() => decide(true)} data-testid="consent-accept" className="px-4 py-2 rounded-full bg-white text-black text-sm font-bold">Accept</button>
        <button onClick={() => decide(false)} data-testid="consent-essential" className="px-4 py-2 rounded-full border border-white/40 text-sm font-bold">Essential only</button>
      </div>
    </div>
  );
}
